module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='header-assets-wrapper'>\n  <h4 class='asset-image-count'></h4>\n  <div class='toggle-asset-view'></div>\n</div>\n<div class='asset-list-view thumbnail-container'>\n  <table class='table-asset-modal table-display table-shaping'>\n    <thead>\n      <tr class='headers'>\n        <th class='active' data-sort-by='title'>\n          <span class='header-text'>Name</span>\n          <span class='icon icon-angle-up'></span>\n        </th>\n        <th data-sort-by='dimensions'>\n          <span class='header-text'>Dimensions</span>\n          <span class='icon'></span>\n        </th>");
      if (this.optionsColumn) {
        $o.push("        <th></th>");
      }
      $o.push("      </tr>\n    </thead>\n    <tbody></tbody>\n  </table>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/assets_collection_list.js.hamlc
// module id = 1559
// module chunks = 18